export class CommunicationType {
  id: number;
  name: string;
  icon: string;
}
